import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  $createParagraphNode,
  $createTextNode,
  $getRoot,
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_LOW,
  PASTE_COMMAND,
} from 'lexical';
import { useEffect } from 'react';
import ReactPlayer from 'react-player';
import { $createVideoNode } from './VideoNode';
import { isValidUrl } from './utils';
import { $createEmbedNode } from './EmbedNode';

export default function AutoEmbedPlugin(): null {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    return editor.registerCommand(
      PASTE_COMMAND,
      (event) => {
        const clipboardData = event.clipboardData;
        if (clipboardData) {
          const text = clipboardData.getData('text/plain');
          const lines = text.split('\n');

          editor.update(() => {
            const selection = $getSelection();
            if ($isRangeSelection(selection)) {
              const nodes = lines.map((line) => {
                const trimmedLine = line.trim();
                if (trimmedLine.length > 0) {
                  if (ReactPlayer.canPlay(trimmedLine)) {
                    return $createVideoNode(trimmedLine);
                  } else if (isValidUrl(trimmedLine)) {
                    return $createEmbedNode(trimmedLine);
                  } else {
                    const paragraphNode = $createParagraphNode();
                    const textNode = $createTextNode(line);
                    paragraphNode.append(textNode);
                    return paragraphNode;
                  }
                } else {
                  return $createParagraphNode();
                }
              });
              selection.insertNodes(nodes);
            }
          });

          // Prevent the default paste behavior.
          event.preventDefault();
          return true;
        }
        return false;
      },
      COMMAND_PRIORITY_LOW
    );
  }, [editor]);
  return null;
}
